"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Reporter = void 0;
var browser_1 = require("./browser");
var api_1 = require("./api");
var offline_1 = require("./browser/offline");
var uuid_1 = require("./utils/uuid");
var fingerprintjs_1 = __importDefault(require("@fingerprintjs/fingerprintjs"));
var manifest_json_1 = __importDefault(require("./manifest.json"));
var log_1 = require("./utils/log");
var DEFAULT_INTERVAL = 10000;
/** 目前数据统计300可以覆盖到大部分的上报 (99.99%) */
var REPORT_TRANSACTION_LIMIT = 300;
var REPORT_TRANSACTION_LIGHT_SIZE = 100;
var REPORT_CHUNK_LIMIT = 4;
var eventTypes = ['api', 'resource', 'customized'];
var performanceTypes = ['navigation'];
var customType = ['custom_accum'];
var internalPluginType = __spreadArray(__spreadArray(__spreadArray([], eventTypes, true), performanceTypes, true), customType, true);
// assert
var isEntryData = function (type, data) { return eventTypes.includes(type); };
var isPerformanceData = function (type, data) { return performanceTypes.includes(type); };
var isAPITimingData = function (type, data) { return type === 'api' && !!data.event_timestamp; };
var isCustomAccumData = function (type, data) { return type === 'custom_accum'; };
var isCustomData = function (type, data) { return customType.includes(data.type || type); };
var isInternalPluginType = function (type) { return internalPluginType.includes(type); };
var getBuildId = function () {
    try {
        return MDAP_SOURCE_MAP_BUILD_ID;
    }
    catch (error) {
        return '';
    }
};
var syncSessionId = function () {
    window.__MDAP_SESSION_ID__ = window.__MDAP_SESSION_ID__ || (0, uuid_1.uuidv4)();
    return window.__MDAP_SESSION_ID__;
};
function externalPluginWarning(type) {
    log_1.Logger.warn("Should not call reporter's triggerhandler cause " + type + " is not an internal plugin type");
}
var Reporter = /** @class */ (function () {
    function Reporter(configs, network) {
        /* default - web performance */
        this.queue = [];
        /* web custom */
        this.customQueue = [];
        this.fingerprint = '';
        this.buildId = '';
        this.labels = {};
        this.tags = {};
        this.session_id = '';
        this.timeOffset = 0;
        this.configs = configs;
        this.userAgent = new browser_1.UserAgent();
        this.network = network;
        this.offlineStore = new offline_1.OfflineStore(configs.app_name, network);
        this.offlineStore.setup();
        this.session_id = syncSessionId();
    }
    /**
     * 在配置初始化之后执行。
    */
    Reporter.prototype.start = function () {
        var _this = this;
        var _a;
        this.buildId = getBuildId();
        this.timer = setInterval(function () {
            _this.check();
        }, (_a = this.configs.interval) !== null && _a !== void 0 ? _a : DEFAULT_INTERVAL);
        // send data before close tab
        var terminationEvent = 'onpagehide' in self ? 'pagehide' : 'unload';
        window.addEventListener(terminationEvent, this.check.bind(this, true), false);
    };
    Reporter.prototype.initFingerprint = function () {
        return __awaiter(this, void 0, void 0, function () {
            var fp, fpResult, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, fingerprintjs_1.default.load()];
                    case 1:
                        fp = _a.sent();
                        return [4 /*yield*/, fp.get()];
                    case 2:
                        fpResult = _a.sent();
                        this.fingerprint = fpResult.visitorId;
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Reporter.prototype.addTrackData = function (type) {
        var _this = this;
        return function (data) {
            var _a;
            log_1.Logger.log("[MDAP report data] " + type + " - ", data);
            if (isCustomData(type, data)) {
                var type_1 = (_a = data.type) !== null && _a !== void 0 ? _a : 'custom_accum';
                _this.customQueue.push({
                    type: type_1,
                    data: _this.attachTags(type_1, data)
                });
            }
            else {
                _this.queue.push({
                    type: type,
                    data: _this.attachTags(type, data)
                });
            }
        };
    };
    Reporter.prototype.serverNow = function (timestamp) {
        var _a;
        // TODO strict validation for timestamp
        return (typeof timestamp === 'number' ? timestamp : new Date().getTime()) + ((_a = this.timeOffset) !== null && _a !== void 0 ? _a : 0);
    };
    Reporter.prototype.addLabels = function (newLabels) {
        try {
            this.labels = __assign(__assign({}, this.labels), newLabels);
        }
        catch (error) {
            log_1.Logger.info('[MDAP] Failed to add new labels');
        }
    };
    Reporter.prototype.register = function (plugin) {
        // 抽样率配置
        try {
            plugin.addLabels = this.addLabels.bind(this);
            plugin.serverNow = this.serverNow.bind(this);
            if (plugin.delegateReporter) {
                plugin.reporter = this;
            }
            var triggerHandler = isInternalPluginType(plugin.type) ? this.addTrackData(plugin.type) : externalPluginWarning;
            plugin.register({
                trigger: triggerHandler,
                app_name: this.configs.app_name,
                env: this.configs.environment
            });
        }
        catch (error) {
            log_1.Logger.log('Failed to register plugin');
            log_1.Logger.error(error);
        }
    };
    Reporter.prototype.unregister = function (plugin) {
        plugin.unregister(this.configs.app_name);
    };
    // check queue
    Reporter.prototype.check = function (pageUnload) {
        if (pageUnload === void 0) { pageUnload = false; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.fingerprint) return [3 /*break*/, 2];
                        // check if fingerprint has been inited. 
                        return [4 /*yield*/, this.initFingerprint()];
                    case 1:
                        // check if fingerprint has been inited. 
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if ('requestIdleCallback' in window && !pageUnload) {
                            requestIdleCallback(this.reportData.bind(this, pageUnload));
                        }
                        else {
                            this.reportData(pageUnload);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Reporter.prototype.getDataChunk = function (queueKey) {
        var _a;
        try {
            var reportDatas = __spreadArray([], this[queueKey], true);
            this[queueKey] = [];
            var chunks = [];
            var chunkCount = 1;
            while (reportDatas.length) {
                var chunk = reportDatas.splice(0, REPORT_TRANSACTION_LIMIT);
                var eventData = queueKey === 'queue' ? this.processData(chunk) : this.processCustomData(chunk);
                if (chunkCount >= REPORT_CHUNK_LIMIT) {
                    eventData.labels = Object.assign({}, (_a = eventData.labels) !== null && _a !== void 0 ? _a : {}, {
                        entries_length: "" + (chunk.length + reportDatas.length)
                    });
                    reportDatas = [];
                }
                chunks.push(eventData);
                chunkCount++;
            }
            return chunks;
        }
        catch (error) {
            log_1.Logger.warn('Failed to process report data.');
            return [];
        }
    };
    Reporter.prototype.handleDataBeforeTerminated = function (queueKey) {
        return __awaiter(this, void 0, void 0, function () {
            var isLightData, chunks, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this[queueKey].length) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        isLightData = this[queueKey].length <= REPORT_TRANSACTION_LIGHT_SIZE;
                        chunks = this.getDataChunk(queueKey);
                        if (!isLightData) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.sendData(chunks[0], true)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        // detect large data before page terminated, cache to localstorage
                        this.offlineStore.cacheData(chunks);
                        return [2 /*return*/, true];
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        error_2 = _a.sent();
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    Reporter.prototype.reportData = function (pageUnload) {
        return __awaiter(this, void 0, void 0, function () {
            var chunks, reportData, chunks, reportData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (pageUnload) {
                            this.handleDataBeforeTerminated('queue');
                            this.handleDataBeforeTerminated('customQueue');
                            return [2 /*return*/];
                        }
                        if (!this.queue.length) return [3 /*break*/, 4];
                        chunks = this.getDataChunk('queue');
                        _a.label = 1;
                    case 1:
                        if (!chunks.length) return [3 /*break*/, 4];
                        reportData = chunks.shift();
                        if (!reportData) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.sendData(reportData)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [3 /*break*/, 1];
                    case 4:
                        if (!this.customQueue.length) return [3 /*break*/, 8];
                        chunks = this.getDataChunk('customQueue');
                        _a.label = 5;
                    case 5:
                        if (!chunks.length) return [3 /*break*/, 8];
                        reportData = chunks.shift();
                        if (!reportData) return [3 /*break*/, 7];
                        return [4 /*yield*/, this.sendData(reportData)];
                    case 6:
                        _a.sent();
                        _a.label = 7;
                    case 7: return [3 /*break*/, 5];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(Reporter.prototype, "commonData", {
        get: function () {
            var _a = this.configs, app_name = _a.app_name, _b = _a.app_version, app_version = _b === void 0 ? 'unknown' : _b, _c = _a.app_build_id, app_build_id = _c === void 0 ? this.buildId || app_version || 'unknown' : _c, _d = _a.user_id, user_id = _d === void 0 ? '' : _d;
            return __assign(__assign({ event_timestamp: this.serverNow(), app_name: app_name, app_version: app_version, app_build_id: app_build_id, user_id: user_id, sdk_name: manifest_json_1.default.name, sdk_version: manifest_json_1.default.version, session_id: this.session_id, tag: 'web-performance' }, this.userAgent.device), { device_id: this.fingerprint, labels: __assign(__assign({}, this.userAgent.browserCompatibility), this.labels) });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Reporter.prototype, "webCommonData", {
        get: function () {
            var _a, _b;
            return __assign(__assign({}, this.userAgent.webData), { region: (_a = this.configs.region) !== null && _a !== void 0 ? _a : 'unknown', environment: (_b = this.configs.environment) !== null && _b !== void 0 ? _b : '' });
        },
        enumerable: false,
        configurable: true
    });
    Reporter.prototype.updateConfig = function (newConfigs) {
        this.configs = Object.assign(this.configs, newConfigs);
    };
    Reporter.prototype.attachTags = function (type, data) {
        var _a, _b;
        if (!Object.keys(this.tags).length) {
            return data;
        }
        try {
            if (isCustomAccumData(type, data)) {
                return __assign(__assign({}, data), { data: __assign(__assign({}, this.tags), ((_a = data.data) !== null && _a !== void 0 ? _a : {})) });
            }
            var isPerformanceEntry = isEntryData(type, data) || isAPITimingData(type, data) || isPerformanceData(type, data);
            if (isPerformanceEntry) {
                return __assign(__assign({}, data), { customized_data: __assign(__assign({}, this.tags), ((_b = data.customized_data) !== null && _b !== void 0 ? _b : {})) });
            }
        }
        catch (error) {
            log_1.Logger.warn('[MDAP] failed to attach tags');
            log_1.Logger.error(error);
            return data;
        }
    };
    Reporter.prototype.processData = function (datas) {
        var _a;
        var perfEntries = [];
        var timings = [];
        var result = __assign(__assign({}, this.commonData), { data: this.webCommonData });
        for (var _i = 0, datas_1 = datas; _i < datas_1.length; _i++) {
            var data = datas_1[_i];
            if (isAPITimingData(data.type, data.data)) {
                var _b = data.data, event_timestamp = _b.event_timestamp, restData = __rest(_b, ["event_timestamp"]);
                timings.push(restData);
                continue;
            }
            if (isEntryData(data.type, data.data)) {
                data.data.type = data.type;
                perfEntries.push(data.data);
                continue;
            }
            if (isPerformanceData(data.type, data.data)) {
                var _c = data.data, event_timestamp = _c.event_timestamp, restData = __rest(_c, ["event_timestamp"]);
                result.data.page_performance = restData;
                result.data.page_performance.offline_bundle = (_a = this.configs.offline_bundle) !== null && _a !== void 0 ? _a : false;
            }
        }
        if (perfEntries.length) {
            result.data.entries = perfEntries;
        }
        if (timings.length) {
            result.data.api_performances = timings;
        }
        return result;
    };
    Reporter.prototype.processCustomData = function (datas) {
        var result = __assign(__assign({}, this.commonData), { tag: 'web-custom', data: this.webCommonData });
        var customAccums = [];
        for (var _i = 0, datas_2 = datas; _i < datas_2.length; _i++) {
            var data = datas_2[_i];
            if (isCustomAccumData(data.type, data.data)) {
                var _a = data.data, type = _a.type, reportData = __rest(_a, ["type"]);
                customAccums.push(reportData);
            }
        }
        result.data.custom_accums = customAccums;
        return result;
    };
    /* 发送数据 */
    Reporter.prototype.sendData = function (data, pageUnload) {
        if (pageUnload === void 0) { pageUnload = false; }
        return __awaiter(this, void 0, void 0, function () {
            var res, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.network.sendRequest({
                                reportData: data,
                                pageUnload: pageUnload
                            })];
                    case 1:
                        res = _a.sent();
                        if (res === api_1.REQUEST_FAILED) {
                            this.offlineStore.cacheData(data);
                        }
                        if (typeof this.onDataSentCallback === 'function') {
                            this.onDataSentCallback(res);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_3 = _a.sent();
                        //
                        this.offlineStore.cacheData(data);
                        log_1.Logger.warn("[MDAP] Failed to send data: " + ((error_3 === null || error_3 === void 0 ? void 0 : error_3.message) || 'unknown reason.'));
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 批量上报数据，失败时保存至本地
     * 仅支持异常数据
     * @param data
     */
    Reporter.prototype.sendBulkData = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var res, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.network.sendBulk({
                                tag: 'web-exception',
                                data: data
                            })];
                    case 1:
                        res = _a.sent();
                        if (res === null || res === void 0 ? void 0 : res.errors) {
                            this.offlineStore.cacheData(data);
                        }
                        if (typeof this.onDataSentCallback === 'function') {
                            this.onDataSentCallback(res);
                        }
                        return [2 /*return*/, res];
                    case 2:
                        error_4 = _a.sent();
                        this.offlineStore.cacheData(data);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Reporter.prototype.onDataSent = function (callback) {
        this.onDataSentCallback = callback;
    };
    Reporter.prototype.close = function () {
        // 把剩余的数据发送出去
        if (this.timer) {
            clearInterval(this.timer);
        }
        this.check();
    };
    return Reporter;
}());
exports.Reporter = Reporter;
